import { render, staticRenderFns } from "./CRUDRotas.vue?vue&type=template&id=03df3642&"
import script from "./CRUDRotas.vue?vue&type=script&lang=js&"
export * from "./CRUDRotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports